'use strict';

import angular from 'angular';
import AddModelController from './addmodel.controller';

export default angular.module('updateServerApp.appconfgroups.addmodel', [])
  .controller('AppConfGroupsAddModelController', AddModelController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfgroups/addmodel/index.js